/**
 * Converts a snake_case string (e.g., "pay_as_you_go") into a readable string
 * with spaces and capitalized words (e.g., "Pay As You Go").
 *
 * @param snakeCaseString The input string in snake_case.
 * @returns The formatted string, or the original string if it's null, undefined, or not a string.
 */
export const formatPlanType = (
  snakeCaseString: string | null | undefined
): string => {
  if (typeof snakeCaseString !== "string") {
    return snakeCaseString || ""; // Return empty string for null/undefined
  }

  // Replace underscores with spaces
  const withSpaces = snakeCaseString.replace(/_/g, " ");

  // Capitalize the first letter of each word
  const formattedString = withSpaces
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return formattedString;
};

// Example Usage:
// logger.info(formatPlanType("free")); // Output: "Free"
// logger.info(formatPlanType("pay_as_you_go")); // Output: "Pay As You Go"
// logger.info(formatPlanType("subscription_tiered")); // Output: "Subscription Tiered"
// logger.info(formatPlanType("credit_based")); // Output: "Credit Based"
// logger.info(formatPlanType("seat_based")); // Output: "Seat Based"
// logger.info(formatPlanType("custom_enterprise")); // Output: "Custom Enterprise"

export const capitalize = (str: string) => {
  if (typeof str !== "string" || str.length === 0) {
    return ""; // Return empty string for non-string or empty input
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// Example usage:
// logger.info(capitalize("hello")); // Output: "Hello"
// logger.info(capitalize("world")); // Output: "World"
// logger.info(capitalize("a"));     // Output: "A"
// logger.info(capitalize(""));      // Output: ""
// logger.info(capitalize(null));   // Output: ""

export const formatDateForInput = (dateString: string | null): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
};

export const getFirstLetter = (str: string | undefined) => {
  return str && str.length > 0 && str[0] ? str[0] : "U";
};
